module.exports = __webpack_public_path__ + "img/arrow-right.01bb4ed1.svg";